import { render, staticRenderFns } from "./InstallIcon.vue?vue&type=template&id=34ac13c1"
import script from "./InstallIcon.vue?vue&type=script&lang=js"
export * from "./InstallIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports